<template>
  <div class="IOContextMenu">
    <v-menu
      v-model="show"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      :rounded="'lg'"
    >
      <v-list>
        <v-list-item
          dense
          v-for="(item, index) in contextMenuItems"
          :key="index"
        >
          <div @click="onClickContextMenu(item.id)" class="d-inline-flex">
            <v-icon small :color="item.color" class="px-1">{{
              item.icon
            }}</v-icon>
            <v-list-item-title> {{ item.title }}</v-list-item-title>
          </div>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import TextUtils from "../../utils/TextUtils";
export default {
  props: {
    x: Number,
    y: Number,
  },

  data() {
    return {
      show: false,
      contextMenuItems: [],
      item: [],
    };
  },
  mounted() {
    this.getContextMenuItems();
  },
  methods: {
    showMenu(item) {
      this.show = true;
      this.item = item;
    },
    hideMenu() {
      this.show = false;
    },
    getContextMenuItems() {
      let vacation = {
        id: "vacation",
        title: this.$t("nav-request-leave"),
        icon: "mdi-calendar-weekend",
        // color: "vacation",
        color: "green",
      };

      let mission = {
        id: "mission",
        title: this.$t("nav-request-mission"),
        icon: "mdi-bag-checked",
        // color: "mission",
        color: "brown",
      };

      let io = {
        id: "io",
        title: this.$t("nav-request-io"),
        icon: "mdi-transit-transfer",
        // color: "io",
        color: "blue",
      };
      let extrawork = {
        id: "extrawork",
        title: this.$t("nav-request-extra-work"),
        icon: "mdi-sort-clock-descending-outline",
        // color: "extrawork",
        color: "red",
      };

      var list = [];
      let permissionList = this.$store.state.permission.permissionList;
      if (permissionList.includes(1)) {
        list.push(vacation);
      }
      if (permissionList.includes(2)) {
        list.push(mission);
      }
      if (permissionList.includes(3)) {
        list.push(io);
      }
      if (permissionList.includes(4)) {
        list.push(extrawork);
      }
      this.contextMenuItems = list;
      return this.contextMenuItems;
    },
    onClickContextMenu(id) {
      //debugger
      var sd = TextUtils.convertToEnglishDigits(this.item.BeginDate);
      if(sd === undefined){
        sd = TextUtils.convertToEnglishDigits(this.item.DDATE)
      }
      switch (id) {
        case "vacation":
          this.$router.push({ name: "request-leave", query: { SD: sd } });
          break;
        case "mission":
          this.$router.push({ name: "request-mission", query: { SD: sd } });
          break;
        case "io":
          this.$router.push({ name: "request-io", query: { SD: sd } });
          break;
        case "extrawork":
          this.$router.push({ name: "request-extra-work", query: { SD: sd } });
          break;
      }
    },
  },
};
</script>

<style>
</style>